module.exports = __webpack_public_path__ + "static/img/cover.005d152.png";


//////////////////
// WEBPACK FOOTER
// ./static/Images/cover.png
// module id = M9wR
// module chunks = 1